import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PresenceIndicatorContainer } from "../../containers/presenceIndicatorContainer";
import { AppModalContainer } from "../../containers/appModalContainer";
import { AudioContainer } from "../../containers/audioContainer";
import { JoystickContainer } from "../../containers/joystickContainer";
import { BottomMenuContainer } from "../../containers/bottomMenuContainer";
import { HelpOverlayContainer } from "../../containers/helpOverlayContainer";
import "./index.css";
import epfl from "../../../../static/images/epfl.png";
import { MenuContainer } from "../../containers/menuContainer";
import { ToastContainer } from "../../containers/toastContainer";
import { LlmContainer } from "../../containers/llmContainer";

const confirmationMessage = "You are about to close this session. Continue?";

const modalConditions = {
  online: ["CLOSED", "CLOSED_BY_ADMIN", "SESSION_TIMEOUT", "SIMULATION_ERROR", "GENERIC_ERROR", "MINIMIZING_ERROR"],
  offline: ["CONNECTION_LOST"],
};

const useConfirmTabClose = (isAdmin, status) => {
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const isSessionEnded = modalConditions.online.includes(status);
      if (isAdmin && !isSessionEnded) {
        event.returnValue = confirmationMessage;
        return confirmationMessage;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isAdmin, status]);
};

const App = ({
  isConnectedToASession,
  isAdmin,
  isOrbitControls,
  isTouch,
  isTryingRoom,
  isOnline,
  status,
  isLoading,
  isSimulation,
}) => {
  const [displayModal, setDisplayModal] = useState(false);
  useConfirmTabClose(isAdmin, status);
  const navigate = useNavigate();

  useEffect(() => {
    if (status === "OFFLINE") {
      navigate("/");
    }

    const shouldDisplayModal =
      (isOnline && modalConditions.online.includes(status)) || (!isOnline && modalConditions.offline.includes(status));

    if (shouldDisplayModal) {
      setDisplayModal(true);
    } else {
      setDisplayModal(false);
    }
  }, [isConnectedToASession, isOnline, status]);

  const appStyle = useMemo(
    () => ({
      ...(isOrbitControls === false && { zIndex: 1 }),
    }),
    [isOrbitControls]
  );

  return (
    <div id="app" className="app" style={appStyle}>
      <PresenceIndicatorContainer />
      <ToastContainer />
      <AudioContainer />
      {isConnectedToASession && !isTryingRoom && isAdmin && <MenuContainer />}
      {isConnectedToASession && !isTryingRoom && isAdmin && isSimulation && <LlmContainer />}
      {(isConnectedToASession || isTryingRoom) && isTouch && <JoystickContainer />}
      {(isConnectedToASession || isTryingRoom) && <HelpOverlayContainer />}
      {(isConnectedToASession || isTryingRoom) && <BottomMenuContainer />}
      {displayModal && <AppModalContainer />}
      {displayModal && <img className="epfl-logo" src={epfl}></img>}
    </div>
  );
};
export default App;
